<template>
  <div
    class="sidebar-header row items-center no-wrap q-py-sm q-px-md"
    >
    <template v-if="searching">
      <search-input
        ref="searchInput"
        :model-value="keyword"
        @update:model-value="$emit('search', $event)"
        @close="$emit('close-search')"
      />
      <q-btn
        size="sm"
        icon="fa fa-times"
        color="grey"
        flat round dense
        @click="$emit('close')"
      />
    </template>
    <template v-else>
      <span class="text-subtitle1 text-weight-bold">People</span>
      <q-space />
      <q-btn
        size="sm"
        icon="fa fa-search"
        color="grey"
        flat round dense
        @click="$emit('open-search')"
      >
        <q-tooltip :delay="400">Search</q-tooltip>
      </q-btn>
      <q-btn
        size="sm"
        icon="fa fa-times"
        color="grey"
        flat round dense
        @click="$emit('close')"
      />
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SearchInput from '@/components/SearchInput.vue';

export default defineComponent({
  emits: ['close', 'close-search', 'open-search', 'search'],
  components: { SearchInput },
  props: {
    searching: {
      type: Boolean,
      default: false,
    },
    keyword: {
      type: String,
      default: '',
    },
  },
  methods: {
    focus() {
      (this.$refs.searchInput as any).focus();
    },
  },
});
</script>

<style scoped>
.sidebar-header {
  border-bottom: 1px solid #e0e0e0;
  min-height: 48px;
}
</style>
